import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

const RedeemVoucherTile = (props) => {
  const[renderType, setRenderType] = useState("");
  const profileDetails = useSelector(state => state.getProfileDetails.profileDetails)
    var profile = props.profile;
    const  handleRedeemVoucherDetails = props.data?.[0]?.ContentRuleZone?.[0]?.attributes
    const  mainImage = props.data?.[0]?.ContentRuleZone?.[0]?.menuImage
    const  altText = props.data?.[0]?.ContentRuleZone?.[0]?.attributes?.altText


    useEffect(()=>{
      if(handleRedeemVoucherDetails.renderPosition) {
        setRenderType(handleRedeemVoucherDetails.renderPosition)
      }
    },[handleRedeemVoucherDetails])

    useEffect(() => {
      if (profileDetails && profileDetails.userTypeCheck && Object.keys(profileDetails.userTypeCheck).length > 0 && !profileDetails.userTypeCheck.showAccount && profileDetails.userSegment['Punchout Session'] === true ) {   
              document.getElementById("redeem-voucher").classList.remove("d-block")
              document.getElementById("redeem-voucher").classList.add("d-none")
      } else {
          console.log('RedeemVoucherTile tile not hidden...')
      }


  }, [profileDetails])

    const hadleRedeemVoucher = (event) => {
      event.preventDefault();
  }
    return (
      <>
      <li id="redeem-voucher" className={`text-center icon-width-popup popover__wrapper c-contact-image d-block ${handleRedeemVoucherDetails?.additionalCss ? handleRedeemVoucherDetails.additionalCss :"" }`}>

      {renderType === "TextOnly"? <Link className='link-icon-style c-utility-nav-label' to={`${handleRedeemVoucherDetails.link ? handleRedeemVoucherDetails.link : "#"}`}>
        <span className='d-block nav-text-hover' style={{cursor:"pointer"}}>{handleRedeemVoucherDetails?.displayName ? handleRedeemVoucherDetails.displayName :"" }</span>
      </Link> 
        : renderType === "IconOnly" ? <Link className='link-icon-style c-utility-nav-label' to={`${handleRedeemVoucherDetails.link ? handleRedeemVoucherDetails.link : "#"}`}>
        {handleRedeemVoucherDetails.menuIcon ? <i class={`${handleRedeemVoucherDetails.menuIcon}`}></i> : mainImage ? <img src={mainImage} alt={altText} className='menu-img'/> :""}
      </Link>
        : renderType === "LeftIconThenText" ? <Link className='link-icon-style c-utility-nav-label d-flex' to={`${handleRedeemVoucherDetails.link ? handleRedeemVoucherDetails.link : "#"}`}>
        {handleRedeemVoucherDetails.menuIcon ? <i class={`${handleRedeemVoucherDetails.menuIcon}`}></i> : mainImage ? <img src={mainImage} alt={altText} className='menu-img'/> :""}
        <span className='d-block nav-text-hover mx-2' style={{cursor:"pointer"}}>{handleRedeemVoucherDetails?.displayName ? handleRedeemVoucherDetails.displayName :"" }</span>
      </Link> 
        : renderType === "LeftTextThenIcon" ? <Link className='link-icon-style c-utility-nav-label d-flex' to={`${handleRedeemVoucherDetails.link ? handleRedeemVoucherDetails.link : "#"}`}>
        <span className='d-block nav-text-hover mx-2' style={{cursor:"pointer"}}>{handleRedeemVoucherDetails?.displayName ? handleRedeemVoucherDetails.displayName :"" }</span>
        {handleRedeemVoucherDetails.menuIcon ? <i class={`${handleRedeemVoucherDetails.menuIcon}`}></i> : mainImage ? <img src={mainImage} alt={altText} className='menu-img'/> :""}
      </Link> 
        : renderType === "TextAboveIcon" ? <Link className='link-icon-style c-utility-nav-label' to={`${handleRedeemVoucherDetails.link ? handleRedeemVoucherDetails.link : "#"}`}>
        {handleRedeemVoucherDetails.menuIcon ? <i class={`${handleRedeemVoucherDetails.menuIcon}`}></i> : mainImage ? <img src={mainImage} alt={altText} className='menu-img'/> :""}
        <span className='d-block nav-text-hover mt-3' style={{cursor:"pointer"}}>{handleRedeemVoucherDetails?.displayName ? handleRedeemVoucherDetails.displayName :"" }</span>
      </Link>
        : renderType === "TextBelowIcon" ? <Link className='link-icon-style c-utility-nav-label ' to={`${handleRedeemVoucherDetails.link ? handleRedeemVoucherDetails.link : "#"}`}>
        <span className='d-block nav-text-hover mb-3' style={{cursor:"pointer"}}>{handleRedeemVoucherDetails?.displayName ? handleRedeemVoucherDetails.displayName :"" }</span>
        {handleRedeemVoucherDetails.menuIcon ? <i class={`${handleRedeemVoucherDetails.menuIcon}`}></i> : mainImage ? <img src={mainImage} alt={altText} className='menu-img'/> :""}
      </Link> 
        : ""}

        {/* <Link className='link-icon-style c-utility-nav-label' to={`${handleRedeemVoucherDetails.link ? handleRedeemVoucherDetails.link : ""}`}>
          <span className='d-block nav-text-hover' style={{cursor:"pointer"}}>{handleRedeemVoucherDetails?.displayName ? handleRedeemVoucherDetails.displayName :"" }</span>
        </Link> */}
        {/* {props && props.targerter && <div class="popover-service-content popover__content c-targeter-content" dangerouslySetInnerHTML={{ __html: props.targerter }}>
        </div>} */}
      </li>
  
    </>
    )
}

export default RedeemVoucherTile